import ModalContainer from "./ModalContainer";

const ProfilePicPreviewModal = ({
  openModal,
  setOpenModal,
  colors,
  profilePic,
}) => {
  return (
    <ModalContainer
      openModal={openModal}
      setOpenModal={setOpenModal}
      colors={colors}
    >
      <img
        alt="profile-user"
        width="500px"
        height="500px"
        src={`http://localhost:5000/${profilePic}`}
        style={{ borderRadius: "50%" }}
      />
    </ModalContainer>
  );
};

export default ProfilePicPreviewModal;
